<script setup lang="ts">

interface Props {
  icon?: `i-${string}:${string}`
  placeholder?: string
  name: string
  required?: string
  type?: string
  showBorder?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  showBorder: true
})

const text = defineModel<string>()

</script>

<template>
  <div 
    :class="[
      'relative inline-flex items-center bg-brand-background rounded-3 border-2',
      showBorder ? 'border-2 border-brand-primary' : 'border-none'
    ]"
  >
    <span 
      v-if="props.icon" 
      :class="[
        'absolute text-base bg-brand-gradient left-0 ml-4',
        icon
      ]"  
    />
    <input
      v-model="text"
      :type="type ? type : 'text'"
      :id="name || ''"
      :placeholder="placeholder ? placeholder : ''"
      :class="[
        'py-3 w-full outline-none bg-transparent rounded-3 text-base sm:text-sm font-semibold text-brand-secondary',
        'placeholder:(text-base sm:text-sm font-bold text-brand-secondary )',
        icon ? 'pl-12 pr-4' : 'px-4',
      ]"
    >
  </div>
</template>